import DeleteIcon from '@mui/icons-material/Delete'
import useStyles from './_styles'

const DeletionBannerDefaultContent = () => {
    const classes = useStyles()

    return (
        <div className={classes.DeletionBannerDefaultContent}>
            <DeleteIcon className={classes.DeletionBannerDefaultContentIcon} />
        </div>
    )
}

export default DeletionBannerDefaultContent
